;(function () {
  'use strict'

  angular
    .module('contrast.trace.events')
    .directive('csTraceEvents', csTraceEvents)

  function csTraceEvents(recursiveDirectiveHelper) {
    'ngInject'

    return {
      restrict: 'E',
      templateUrl: 'components/trace-events/cs-trace-events.html',
      controller: 'csTraceEventsCtrl',
      controllerAs: 'eventsCtrl',
      scope: {},
      bindToController: {
        events: '=',
        traceUuid: '=',
        traceLanguage: '='
      },
      compile: recursiveDirectiveHelper.compile
    }
  }
})()
